import { Navigate } from "react-router"

export const ProtectedRoute  = ({ auth, children }) => {
  if (!auth) {
    return <Navigate to={"/:lang"} replace />
  }

  return children
};